import { useQuery } from "@apollo/client";
import { TOP_5_CLIP } from "../../GraphQL/top5";
import { MOCK_TOP_5_PLAYERS } from "./mockData";

export const Top5WidgetViewModel = () => {
  const { data, loading } = useQuery(TOP_5_CLIP);

  const rawClip = data?.clipsNew?.nodes[0];

  const clip = rawClip
    ? {
        ...rawClip,
        associatedUsers: rawClip.associatedUsers?.length
          ? rawClip.associatedUsers
          : MOCK_TOP_5_PLAYERS,
      }
    : null;

  return {
    loading,
    clip,
  };
};
